import {
  GET_TEAMS,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_FAILURE,
  ASSIGN_TEAM,
  ASSIGN_TEAM_SUCCESS,
  ASSIGN_TEAM_FAILURE,
  UNASSIGN_TEAM,
  UNASSIGN_TEAM_SUCCESS,
  UNASSIGN_TEAM_FAILURE,
  RESET_TEAM_SUCCESS,
  API_FAILED,
} from "./constants";

const INIT_STATE = {
  teams: [],
  loading: false,
  error: null,
  assignLoading: false,
  assignError: null,
  assignSuccess: false,
  unassignLoading: false,
  unassignError: null,
  unassignSuccess: false,
};

const Teams = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TEAMS:
      return {
        ...state,
        loading: true,
        error: null,
        assignSuccess: false,
        unassignSuccess: false,
      };
    case GET_TEAMS_SUCCESS:
      return {
        ...state,
        teams: action.payload,
        loading: false,
        error: null,
      };
    case GET_TEAMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ASSIGN_TEAM:
      return {
        ...state,
        assignLoading: true,
        assignError: null,
        assignSuccess: false,
      };
    case ASSIGN_TEAM_SUCCESS:
      return {
        ...state,
        assignLoading: false,
        assignError: null,
        assignSuccess: true,
      };
    case ASSIGN_TEAM_FAILURE:
      return {
        ...state,
        assignLoading: false,
        assignError: action.payload,
        assignSuccess: false,
      };
    case UNASSIGN_TEAM:
      return {
        ...state,
        unassignLoading: true,
        unassignError: null,
        unassignSuccess: false,
      };
    case UNASSIGN_TEAM_SUCCESS:
      return {
        ...state,
        unassignLoading: false,
        unassignError: null,
        unassignSuccess: true,
      };
    case UNASSIGN_TEAM_FAILURE:
      return {
        ...state,
        unassignLoading: false,
        unassignError: action.payload,
        unassignSuccess: false,
      };
    case RESET_TEAM_SUCCESS:
      return {
        ...state,
        assignSuccess: false,
        unassignSuccess: false,
      };
    case API_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return { ...state };
  }
};

export default Teams;
